import { useEffect } from 'react';

/**
 * Custom hook to handle Escape key press for closing modals, dialogs, etc.
 * @param onEscape - Callback function to execute when Escape key is pressed
 * @param enabled - Whether the hook should be active (default: true)
 */
export function useEscapeKey(onEscape: () => void, enabled: boolean = true): void {
  useEffect(() => {
    if (!enabled) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onEscape, enabled]);
}
